import { Row, Col, Label } from "reactstrap"
import DatetimeRenderer from "../../../../../Material/DatetimeRenderer"

export default function RiskDrivingProfile({ driver }) {

    return (
        <>
            <h4>Behavior Score</h4>
            <div>
                {driver?.customerRating?.length ? (
                    <>
                        <Row>
                            <Col xs={4}><Label>Weekend Date</Label></Col>
                            <Col xs={4}><Label>Percentile</Label></Col>
                            <Col xs={4}><Label>Traffic Light Rating</Label></Col>
                        </Row>
                        {driver.customerRating.map((record, i) => (
                            <Row key={i}>
                                <Col>
                                    <p>{record.weekendDate ? <DatetimeRenderer datetime={record.weekendDate} /> : "--"}</p>
                                </Col>
                                <Col>
                                    <p>{record.percentile || "--"}</p>
                                </Col>
                                <Col>
                                    <p>{record.trafficLightRating || "--"}</p>
                                </Col>
                            </Row>
                        ))}
                    </>
                ) : (
                    <p>No Customer Rating Found From EDW</p>
                )}
            </div>
        </>
    )
}
